


import React from "react";
import "./Vehicles.css";

const vehicles = [
  {
    id: 1,
    name: "Swift Dzire",
    type: "Sedan",
    price: "Book Now",
    image: "/images/Fleet/Swift-Dzire.jpg",
    seats: "4+1 Seats",
    bags: "2 Bags",
    ac: "Air Conditioned",
    transmission: "Manual / Auto",
  },
  {
    id: 2,
    name: "Maruti Ertiga",
    type: "Family MPV",
    price: "Book Now",
    image: "/images/Fleet/Maruti-Ertiga.jpeg",
    seats: "6+1 Seats",
    bags: "3 Bags",
    ac: "Air Conditioned",
    transmission: "Manual",
  },
  
  {
    id: 3,
    name: "Toyota Rumion",
    type: "Premium MPV",
    price: "Book Now",
    image: "/images/Fleet/Toyota-Rumion.jpeg",
    seats: "6+1 Seats",
    bags: "3 Bags",
    ac: "Air Conditioned",
    transmission: "Manual",
  },
  {
    id: 4,
    name: "Kia Carens",
    type: "Luxury MPV",
    price: "Book Now",
    image: "/images/Fleet/Kia-Carens.jpg",
    seats: "6+1 Seats",
    bags: "4 Bags",
    ac: "Dual AC",
    transmission: "Manual",
  },
  // {
  //   id: 5,
  //   name: "Innova Cab",
  //   type: "SUV",
  //   price: "Book Now",
  //   image: "/images/Fleet/Innova-Cab.jpg",
  //   seats: "7 Seats",
  //   bags: "4 Bags",
  //   ac: "Air Conditioned",
  //   transmission: "Manual",
  // },
  {
    id: 6,
    name: "Innova Crysta",
    type: "Premium SUV",
    price: "Book Now",
    image: "/images/Fleet/Innova-Crysta.jpg",
    seats: "7 Seats",
    bags: "5 Bags",
    ac: "Climate AC",
    transmission: "Manual",
  },
  {
    id: 7,
    name: "Tempo Traveller",
    type: "Traveller",
    price: "Book Now",
    image: "/images/Fleet/Tempo-Traveller.jpeg",
    seats: "12-17 Seats",
    bags: "10 Bags",
    ac: "Air Conditioned",
    transmission: "Manual",
  },
  // {
  //   id: 8,
  //   name: "Urbania Bus",
  //   type: "Luxury Van",
  //   price: "Book Now",
  //   image: "/images/Fleet/Urbania-Bus.jpg",
  //   seats: "13-17 Seats",
  //   bags: "12 Bags",
  //   ac: "Luxury AC",
  //   transmission: "Manual",
  // },
  // {
  //   id: 9,
  //   name: "Mini Bus",
  //   type: "Mini Bus",
  //   price: "Book Now",
  //   image: "/images/Fleet/Mini-Bus.jpg",
  //   seats: "20-25 Seats",
  //   bags: "20 Bags",
  //   ac: "Air Conditioned",
  //   transmission: "Manual",
  // },
];

const Vehicles = () => {
    return (
    <section className="vehicles-section p-0">

      <div className="vehicles-container">

        {/* Heading */}

        <div className="vehicles-heading">

          <div className="heading-title">

            <div className="heading-line left">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <h2>Our Premium Fleet</h2>

            <div className="heading-line right">
              <span></span>
              <span></span>
              <span></span>
            </div>

          </div>

          <p>
            Shreesha Tours & Travels offers clean, well-maintained and
            chauffeur-driven vehicles for Mumbai Airport Transfers,
            Navi Mumbai Taxi Service, Local City Travel and Outstation Cab
            Booking across Maharashtra and India.
          </p>

        </div>

        {/* Fleet Cards */}

        <div className="vehicle-grid">

          {vehicles.map((car, index) => (

            <div
              className="vehicle-card"
              key={index}
            >

              <a
                href="/booking"
                className="vehicle-image"
              >

                <img
                  src={car.image}
                  alt={car.name}
                />

              </a>

              <div className="vehicle-content">

                <div className="vehicle-top">

                  <div>

                    <h3 className="text-danger">{car.name}</h3>

                    <span>{car.type}</span>

                  </div>

                  <div className="price">

                    <strong>{car.price}</strong>

                    <span>24×7 Service</span>

                  </div>

                </div>

                <div className="vehicle-info text-center">
                                    <div>
                    <i className="fa-solid fa-users"></i>
                    <span>{car.seats}</span>
                  </div>

                  <div>
                    <i className="fa-solid fa-suitcase"></i>
                    <span>{car.bags}</span>
                  </div>

                  <div>
                    <i className="fa-solid fa-snowflake text-center"></i>
                    <span>{car.ac}</span>
                  </div>

                  {/* <div>
                    <i className="fa-solid fa-gear"></i>
                    <span>{car.transmission}</span>
                  </div> */}

                </div>

                <div className="vehicle-buttons">

                  {/* <a
                    href={`https://wa.me/918355835813?text=Hello%20Shreesha%20Tours%20%26%20Travels,%20I%20want%20to%20book%20${encodeURIComponent(
                      car.name
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rent-btn"
                  >
                    <i className="fa-brands fa-whatsapp"></i>
                    Book Now
                  </a> */}
{/* 
                  <a
                    href="tel:+918355835813"
                    className="details-btn"
                  >
                    <i className="fa-solid fa-phone"></i>
                    Call Now
                  </a> */}

                </div>

              </div>

            </div>

          ))}

        </div>
              </div>

    </section>
  );
};

export default Vehicles;